import { ButtonWithIcon, Spacer } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { BankMaintenanceSideModal } from 'src/pages/Disbursement/components/Maintenance/BankMaintenanceSideModal/BankMaintenanceSideModal';
import { useApiDisburseListActionButton } from './useApiDisburseListActionButton';

const ApiDisburseListActionButton = () => {
  const { showVendorMaintenance, showSideModal, handleToggleSideModal } =
    useApiDisburseListActionButton();

  return (
    <>
      <Link id="apiDisburse_btnSetting" to={'/settings/bulk-receipt'}>
        <ButtonWithIcon
          iconName="configs"
          style={{
            backgroundColor: 'transparent',
            border: '1px solid #D2D5D7',
          }}
          color={ButtonWithIcon.Color.Secondary}
          buttonType={ButtonWithIcon.Type.Outlined}
        ></ButtonWithIcon>
      </Link>
      {showVendorMaintenance && (
        <Spacer left={Spacer.Size.M}>
          <ButtonWithIcon
            isDedupe
            iconName="bank"
            color={ButtonWithIcon.Color.Secondary}
            buttonType={ButtonWithIcon.Type.Outlined}
            onClick={handleToggleSideModal}
          ></ButtonWithIcon>
        </Spacer>
      )}
      {showSideModal && (
        <BankMaintenanceSideModal
          source="button_api_disburse_list"
          show={showSideModal}
          handleToggleSideModal={handleToggleSideModal}
        />
      )}
    </>
  );
};
export default ApiDisburseListActionButton;
